import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ children }: any) => {
  const { isAuth } = useAuth();

  return isAuth ? children : <Navigate to="/" />;
};

export default PrivateRoute;
